module.exports = __webpack_public_path__ + "static/mann-am-serviceschalter-d91c4ba824562e1686b4bce906c4e94d.png";